<template>
  <div class="report-tools">
    <div class="report-tabs">
      <div
        :class="['report-tabs-item', tab == 0 ? 'active' : '']"
        @click="$emit('changeTab', 0)"
      >
        <span class="report-tabs-text">Report</span>
      </div>

      <div
        :class="['report-tabs-item', tab == 1 ? 'active' : '']"
        @click="$emit('changeTab', 1)"
      >
        <span class="report-tabs-text">Report conclusions</span>
      </div>

      <div
        :class="['report-tabs-item', tab == 2 ? 'active' : '']"
        @click="$emit('changeTab', 2)"
      >
        <span class="report-tabs-text">Error conclusions</span>
      </div>

      <div
        :class="['report-tabs-item', tab == 3 ? 'active' : '']"
        @click="$emit('changeTab', 3)"
      >
        <span class="report-tabs-text">Inconsistencies</span>
      </div>

      <div
        :class="['report-tabs-item', tab == 4 ? 'active' : '']"
        @click="$emit('changeTab', 4)"
      >
        <span class="report-tabs-text">Statistics</span>
      </div>

      <div
        :class="['report-tabs-item', tab == 5 ? 'active' : '']"
        @click="$emit('changeTab', 5)"
      >
        <span class="report-tabs-text">History</span>
      </div>
    </div>

    <div class="report-tools-wrapper">
      <button @click="print" class="btn btn-onlytext btn-print">
        <svg class="icon">
          <use xlink:href="/img/icons/icons-sprite.svg#print" />
        </svg>
        <span>Print</span>
      </button>

      <button @click="exportData" class="btn btn-onlytext btn-export">
        <svg class="icon">
          <use xlink:href="/img/icons/icons-sprite.svg#export" />
        </svg>
        <span>Export</span>
      </button>

      <component :is="actionsComponent" :accepted="customerSended" :errorsDataToSend="errorsDataToSend" />

    </div>
  </div>
</template>

<script>
import Api from '@/utils/api';
import helpers from '@/mixins/helpers';
import { ROLE_QA_EXPERT, ROLE_PROJECT_MNG, ROLE_LSP, ROLE_CUSTOMER, ROLE_SYSTEM_ADMIN, ROLE_QA_MANAGER, ROLE_PROOF_READER } from '@/utils/const';

export default {
  props: {
    tab: {
      type: Number,
      default: 0,
    },
    customerSended: {
      type: Boolean,
      default: () => false,
    },
    lspSended: {
      type: Boolean,
      default: () => false,
    },
  },
  mixins: [helpers.general],
  components: {
    'c-btn': () => import('@/components/button/index.vue'),
    'actions-qaexpert': () => import('./sendBtn/QAExpert.vue'),
    'actions-qamanager': () => import('./sendBtn/QAManager.vue'),
    'actions-pm': () => import('./sendBtn/PM.vue'),
    'actions-lsp': () => import('./sendBtn/LSP.vue'),
    'actions-proofreader': () => import('./sendBtn/Proofreader.vue'),
    'actions-admin': () => import('./sendBtn/Admin.vue'),
    'actions-customer': () => import('./sendBtn/PM.vue'),
    'actions-empty': () => import('./sendBtn/empty.vue'),
  },
  data() {
    return {
      ajaxLoading: false,
      sendCustomer: false,
      sendLsp: false,
    };
  },
  mounted() {
    this.sendCustomer = this.customerSended;
    this.sendLsp = this.lspSended;
  },
  computed: {
    printReport() {
      return this.checkPermissions('report', 'report-print');
    },
    exportReport() {
      return this.checkPermissions('report', 'report-export');
    },
    errorsDataToSend() {
      return this.$store.getters.getDataSendCustomer;
    },
    actionsComponent() {
      switch (this.$store.getters.userRole) {
      case ROLE_QA_EXPERT: return 'actions-qaexpert';
      case ROLE_PROJECT_MNG: return 'actions-pm';
      case ROLE_LSP: return 'actions-lsp';
      case ROLE_CUSTOMER: return 'actions-customer';
      case ROLE_SYSTEM_ADMIN: return 'actions-admin';
      case ROLE_QA_MANAGER: return 'actions-qamanager';
      case ROLE_PROOF_READER: return 'actions-proofreader';
      default: return 'actions-empty';
      }
    },
  },
  methods: {
    exportData() {
      this.$root.$emit('notification', {
        message: 'In developing',
        type: 'attention',
        show: true,
      });
    },

    sendToCustomerData() {
      if (this.errorsDataToSend.ErrorConclusionList.length != 0) {
        this.ajaxLoading = true;
        Api.reports.sendToCustomer(this.errorsDataToSend).then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'info',
              show: true,
            });

            this.sendCustomer = true;
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        }).finally(() => {
          this.ajaxLoading = false;
        });
      }
    },

    sendToLspData() {
      this.ajaxLoading = true;

      Api.reports.sendToLsp(this.$route.params.id).then((response) => {
        if (response.data.Status) {
          this.$root.$emit('notification', {
            message: response.data.Message,
            type: 'info',
            show: true,
          });

          this.sendLsp = true;
        } else {
          this.$root.$emit('notification', {
            message: response.data.Message,
            type: 'error',
            show: true,
          });
        }
      }).finally(() => {
        this.ajaxLoading = false;
      });
    },

    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss">
.report {
  &-tools {
    @include flex(row, space-between);
    border: 1px solid $color-white;
    margin-bottom: 2px;
    box-shadow: $shadow;

    &-wrapper {
      @include flex(row, $item: center);
    }

    .btn {
      @include flex(row, center, center);
      height: 100%;

      .icon {
        width: 18px;
        height: 18px;
        margin-right: 10px;
        fill: $color-white;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      &-print,
      &-export {
        padding: 0 10px;
        color: $color-gray_dark;
        transition: background 0.3s $transition;

        .icon {
          margin-right: 5px;
          fill: $color-gray_dark;
        }

        &:hover {
          background: $color-blue;
          color: $color-white;

          .icon {
            fill: $color-white;
          }
        }
      }
    }
  }

  &-tabs {
    @include flex(row, $item: center);

    &-item {
      @include flex(row, center, center);
      padding: 0 16px;
      height: 46px;
      cursor: pointer;
      transition: background-color 0.3s $transition;

      &:not(:first-child) {
        border-left: 1px solid #e3e3e3;
      }

      &:hover {
        background-color: $color-white;
      }

      &.active {
        padding: 0 16px;
        background-color: $color-white;

        .report-tabs-text {
          color: $color-title;
          cursor: auto;
        }
      }
    }

    &-text {
      color: $color-gray_dark;
    }
  }
}
</style>
